var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.tags),function(tag,index){return _c('v-chip',{key:index,staticClass:"ml-1 float-left mb-2",attrs:{"color":"#F0F0F0","x-small":""}},[_vm._v(" "+_vm._s(tag)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }